/**
 * Masks the account holder name by showing only the first and last character
 * Example: "Emma Williams" -> "E***s"
 * @param {string} name - The account holder name
 * @returns {string} - The masked name or "N/A" if empty
 */
export const maskAccountDetail = (name) => {
    if (!name || typeof name !== 'string') return "N/A";

    const trimmedName = name.trim();

    if (trimmedName.length === 0) return "N/A";
    if (trimmedName.length === 1) return trimmedName;
    if (trimmedName.length === 2) return trimmedName;

    const firstChar = trimmedName.charAt(0);
    const lastChar = trimmedName.charAt(trimmedName.length - 1);
    const middleLength = trimmedName.length - 2;
    const asterisks = '*'.repeat(middleLength);

    return firstChar + asterisks + lastChar;
};
